module.exports = __webpack_public_path__ + "static/img/lenovo.e3d908a6.png";